import { c as _c } from "react/compiler-runtime";
import React, { useMemo, useCallback } from 'react';
import { Helmet } from 'react-helmet-async';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import ProgressLoader from 'components/essentials/ProgressLoader/ProgressLoader';
import { GET_MODULAR_SOFA_COLLECTIONS_STATIC } from 'mocks/queries';
import { MODULAR_SOFAS_PAGE_SEO_DESCRIPTION } from 'commons/constants';
import getVisitorLocationQueryVariables from 'commons/getVisitorLocationQueryVariables';
import useUserLocation from 'global-state/userLocation/useUserLocation';
import ModularSofasCollection from './components/ModularSofasCollection';
import ModularTopNav from './components/ModularTopNav';
import { prepareCollectionDataStatic } from './utils';
import { collectionQuickLinks } from './collectionOrder';
const ModularSofasPage = () => {
  const $ = _c(17);
  const userLocation = useUserLocation();
  const t0 = userLocation?.stateShortName;
  let t1;
  if ($[0] !== t0) {
    t1 = getVisitorLocationQueryVariables(t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      variables: t1
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    data: collectionQueryData,
    loading
  } = useSuspenseQuery(GET_MODULAR_SOFA_COLLECTIONS_STATIC, t2);
  const onTopNavClick = _temp;
  let t3;
  bb0: {
    if (collectionQueryData?.collections) {
      let t4;
      if ($[4] !== collectionQueryData.collections) {
        t4 = prepareCollectionDataStatic(collectionQueryData.collections);
        $[4] = collectionQueryData.collections;
        $[5] = t4;
      } else {
        t4 = $[5];
      }
      t3 = t4;
      break bb0;
    }
    t3 = null;
  }
  const finalCollectionData = t3;
  let t4;
  if ($[6] !== finalCollectionData) {
    t4 = finalCollectionData?.filter(_temp2) ?? [];
    $[6] = finalCollectionData;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const quickLinksData = t4;
  if (loading || !finalCollectionData) {
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="ModularSofasStatic__container"><div className="flex flex-col min-h-[30vh] items-center"><ProgressLoader /></div></div>;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    return t5;
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Helmet><title>{"Modular Sofas, Sectionals, & Couches | Joybird"}</title><meta name="keywords" content="modular sofa" /><meta name="description" content={MODULAR_SOFAS_PAGE_SEO_DESCRIPTION} /><meta property="og:type" content="website" /><meta property="og:description" content={MODULAR_SOFAS_PAGE_SEO_DESCRIPTION} /><meta property="og:url" content="https://joybird.com/modular-sofas/" /></Helmet>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== quickLinksData) {
    t6 = <ModularTopNav collectionData={quickLinksData} onTopNavClick={onTopNavClick} />;
    $[10] = quickLinksData;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== finalCollectionData) {
    t7 = finalCollectionData.map(_temp3);
    $[12] = finalCollectionData;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t6 || $[15] !== t7) {
    t8 = <>{t5}<div className="ModularSofasPage__container"><div className="flex flex-col">{t6}{t7}</div></div></>;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};
export default ModularSofasPage;
function _temp(collectionId) {
  if (typeof document === "undefined") {
    return;
  }
  document.getElementById(`collection-${collectionId}`)?.scrollIntoView({
    behavior: "smooth",
    block: "start"
  });
}
function _temp2(collection) {
  return collectionQuickLinks.includes(collection.name);
}
function _temp3(collection_0, index) {
  return <ModularSofasCollection key={collection_0.id} className={(index + 1) % 2 === 0 ? "bg-gray-light9" : ""} collection={collection_0} collectionIndex={index} />;
}